import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import JSZip from 'jszip';
import pusher from "./components/pusher";
import sendLogoutForm from "./helpers/send-logout-form";
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

window.$ = window.jQuery = $;
window.JSZip = JSZip;
window.bootstrap = bootstrap;

document.addEventListener('DOMContentLoaded', init);

export const STATUS_CODE_NO_CONTENT = 204;

function init() {
  const goTopBtn = $('.back-to-top');

  /////////////////////////////////////////////////////
  // Show or hide the buttonToTop if page scrolling  //
  /////////////////////////////////////////////////////
  function trackScroll() {
    const scrolled = $(window).scrollTop();
    const coords = $(window).height();
    if (scrolled > coords) {
      goTopBtn.addClass('back-to-top-show');
    }
    if (scrolled < coords) {
      goTopBtn.removeClass('back-to-top-show');
    }
  }

  ////////////////////////////////
  // Scrolling page to the top  //
  ////////////////////////////////
  function backToTop() {
    if (window.scrollY > 0) {
      $('body,html').animate({scrollTop: 0}, 800);
    }
  }

  ///////////////////////////
  // Button click handling //
  ///////////////////////////
  $(document).on('click', '.back-to-top-show', function () {
    backToTop();
  });

  ///////////////////////////
  // Page scrolling handling //
  ///////////////////////////
  $(document).on('scroll', function () {
    trackScroll();
  });

  ////////////////////////////
  // Checking button status //
  ////////////////////////////
  trackScroll();

  ////////////
  // Pusher //
  ////////////
  pusher();

  //////////////////
  // Logout event //
  //////////////////
  sendLogoutForm();
}
